import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GatemanService } from '../../services/gateman.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
  @Input() config;
  @Input() controls;
  default: string;

  /*
   * @author - SwapnilP
   * @task - QLIKTAG-2922
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gatemanService: GatemanService
  ) { }

  /*
   * @author - SwapnilP
   * @task - QLIKTAG-2922
   */
  ngOnInit() {
    this.default = this.activatedRoute.snapshot.fragment;
    // if (this.config.tabs) {
    //   this.config.tabs = this.config.tabs.sort((a, b) => a.order - b.order);
    // }
  }

  /**
   * [ Called whenever tab is changed, binded to ionChange event emmitter ]
   * @param  event [ segment change event ]
   * @return    [Nothing]
   * @author - SwapnilP
   * @task - QLIKTAG-2922
   */
  segmentChanged(event) {
    //console.log('Segment changed', event);
    const tabName = event.detail.value;
    const activeTab = this.controls.find(tab => tab.config.name === tabName);
    const tabConfig = activeTab && activeTab.hasOwnProperty('config') ? activeTab.config : {};
    if (tabConfig && tabConfig.hasOwnProperty('url') && tabConfig.url) {
      this.gatemanService.routeHub(tabConfig.url);
    } else {
      // Will trigger route change and so call resolvers of MainRoutingModule
      // Extra page set will be there.
      // Also how detail page route will be after fragment is placed?
      // skipLoadPage - Prevents extra load of page in main component upon chaning tab
      //console.log('skipLoadPage')
      this.router.navigate([], { relativeTo: this.activatedRoute, fragment: tabConfig.name, queryParamsHandling: 'merge' });
    }
  }
}
